import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import {percent} from 'js/common/string_helper';
import locations from './states_countries_info';

const STATES = window.sn.StateCodes;
const COUNTRIES = window.sn.CountryCodes;

class LocationAnalytics extends Component {
    calculateLocations = () => {
        const {countries, states} = this.props;

        const countryCount = R.omit(['us'], countries.counts);
        const countriesArr = R.reduce(
            (countryArr, country) => {
                if (R.has(country, COUNTRIES)) {
                    countryArr.push({
                        name: country,
                        count: countryCount[country],
                        type: 'countries'
                    });
                }
                return countryArr;
            },
            [],
            R.keys(countryCount)
        );

        const stateCount = states.counts;
        const statesArr = R.reduce(
            (stateArr, state) => {
                if (R.has(state, STATES)) {
                    stateArr.push({
                        name: state,
                        count: stateCount[state],
                        type: 'states'
                    });
                }
                return stateArr;
            },
            [],
            R.keys(stateCount)
        );

        const locationsArr = countriesArr.concat(statesArr);

        const topFiveLocations = R.pipe(
            R.sort((a, b) => b.count - a.count),
            R.slice(0, 5)
        )(locationsArr);

        return topFiveLocations;
    };

    displayLocations = places => {
        const {countries, states, getAssetPath} = this.props;

        return R.map(location => {
            if (location.type === 'states') {
                const stateName = location.name;
                const fullState = STATES[stateName];

                return (
                    <div className="location-container">
                        <img src={getAssetPath(locations[fullState.toLowerCase()])} />
                        <div className="location-percentage">
                            {percent(states.percentages[stateName], 0)}
                        </div>
                        <div className="location-name">{fullState.toUpperCase()}</div>
                    </div>
                );
            }
            const countryName = location.name;
            const fullCountry = COUNTRIES[countryName];

            return (
                <div className="location-container">
                    <img src={getAssetPath(locations.world)} />
                    <div className="location-percentage">
                        {percent(countries.percentages[countryName], 0)}
                    </div>
                    <div className="location-name">{fullCountry.toUpperCase()}</div>
                </div>
            );
        }, places);
    };

    render() {
        const {borders, renderForPdf} = this.props;
        const locationAnalyticsClasses = classNames('location-analtyics', {
            'container-border-top': borders.top,
            'container-border-right': borders.right,
            'container-border-bottom': borders.bottom,
            'container-border-left': borders.left
        });
        const topLocations = this.calculateLocations();
        const locations = this.displayLocations(topLocations);
        // TODO: handle < 5 locations

        return (
            <div className={locationAnalyticsClasses}>
                <div className="location-header">
                    <div className="location-header-title">TOP 5 LOCATIONS</div>
                </div>
                <div className="location-percentages">
                    <div className="location-percentages-col-1">
                        {locations[0]}
                        {locations[1]}
                    </div>
                    <div className="location-percentages-col-2">{locations[2]}</div>
                    <div className="location-percentages-col-3">
                        {locations[3]}
                        {locations[4]}
                    </div>
                </div>

                {/*STYLES*/}

                <style>{`
                    .location-analytics {
                        width: 50%;
                        padding-bottom: 60px;
                    }

                    .location-header {
                        padding: 40px 0px 20px 0px;
                    }

                    .location-header-title {
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                    }

                    .location-percentages-col-2 {
                        padding: 0px 20px;
                    }

                    .location-container {
                        padding: 24px;
                    }

                    .location-percentage {
                        font-size: 30px;
                        font-weight: bold;
                        color: #4ed2c3;

                    }

                    .location-name {
                        font-size: 12px;
                        font-weight: bold;
                    }

                    .container-border-top {
                        border-top: 1px solid #d4d4d4;
                    }

                    .container-border-right {
                        border-right: 1px solid #d4d4d4;
                    }

                    .container-border-bottom {
                         border-bottom: 1px solid #d4d4d4;
                    }

                    .container-border-left {
                        border-left: 1px solid #d4d4d4;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .location-analytics {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .location-header {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .location-percentages {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        .location-percentages-col-1,
                        .location-percentages-col-2,
                        .location-percentages-col-3 {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .location-container {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .location-header {
                            text-align: center;
                        }

                        .location-percentages-col-1,
                        .location-percentages-col-2,
                        .location-percentages-col-3 {
                            display: inline-block;
                            vertical-align: middle;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

LocationAnalytics.propTypes = {};

export default LocationAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/location_analytics.js